import { useEffect, useState } from "react";
import { Download, FileText, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { fullName } from "@/lib/demo/utils";
import { fetchBlobUrl, apiError } from "@/lib/api";
import { useI18n } from "@/lib/i18n/i18n";

export async function downloadCandidateCv(p, t) {
  try {
    const url = await fetchBlobUrl(`/company/candidates/${p.id}/cv?download=true`);
    const a = document.createElement("a");
    a.href = url;
    a.download = p.cvFileName || "CV.pdf";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  } catch (e) {
    toast.error(t(apiError(e).message));
  }
}

export const CvDialog = ({ participant, onClose }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);
  const { t } = useI18n();

  useEffect(() => {
    if (!participant) return undefined;
    let u = null;
    let alive = true;
    setUrl(null);
    setError(null);
    fetchBlobUrl(`/company/candidates/${participant.id}/cv`).then((x) => { u = x; if (alive) setUrl(x); else URL.revokeObjectURL(x); }).catch((e) => alive && setError(apiError(e).message));
    return () => { alive = false; if (u) URL.revokeObjectURL(u); };
  }, [participant]);

  return (
    <Dialog open={!!participant} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="flex h-[88vh] max-w-4xl flex-col gap-4 p-5 sm:p-6" data-testid="cv-dialog">
        {participant && (
          <>
            <DialogHeader className="flex-row items-center justify-between gap-4 space-y-0 pr-8">
              <div className="flex min-w-0 items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-upv-light text-upv"><FileText className="h-5 w-5" /></span>
                <div className="min-w-0 text-left">
                  <DialogTitle className="truncate font-mono text-sm" data-testid="cv-dialog-filename">{participant.cvFileName}</DialogTitle>
                  <DialogDescription className="text-xs">{fullName(participant)} · {t("PDF subido por el participante")}</DialogDescription>
                </div>
              </div>
              <Button size="sm" variant="outline" onClick={() => downloadCandidateCv(participant, t)} data-testid="cv-dialog-download-button">
                <Download className="mr-2 h-4 w-4" /> {t("Descargar")}
              </Button>
            </DialogHeader>
            {error && <p className="rounded-xl bg-rose-50 p-4 text-sm text-rose-700">{t(error)}</p>}
            {!url && !error && <div className="flex flex-1 items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>}
            {url && <iframe title="CV" src={url} className="w-full flex-1 rounded-xl border border-slate-200 bg-slate-100" data-testid="cv-dialog-iframe" />}
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
